// Trigger endpoint injection by importing each file, then re-export all hooks.
import "@/modules/loan/store/services/endpoints/get-loans";
import "@/modules/loan/store/services/endpoints/get-loans-kanban";
import "@/modules/loan/store/services/endpoints/get-loan";
import "@/modules/loan/store/services/endpoints/get-loan-lenders-heat-map";
import "@/modules/loan/store/services/endpoints/add-loan";
import "@/modules/loan/store/services/endpoints/patch-loan";
import "@/modules/loan/store/services/endpoints/delete-loan";

export { useGetLoansQuery } from "@/modules/loan/store/services/endpoints/get-loans";
export { useGetLoansKanbanQuery } from "@/modules/loan/store/services/endpoints/get-loans-kanban";
export { useGetLoanQuery } from "@/modules/loan/store/services/endpoints/get-loan";
export { useGetLoanLendersHeatMapQuery } from "@/modules/loan/store/services/endpoints/get-loan-lenders-heat-map";
export { useAddLoanMutation } from "@/modules/loan/store/services/endpoints/add-loan";
export { usePatchLoanMutation } from "@/modules/loan/store/services/endpoints/patch-loan";
export { useDeleteLoanMutation } from "@/modules/loan/store/services/endpoints/delete-loan";

